import styled from "styled-components";
import { Wrapper } from '../GridItem/GridItem.styles'

export const TransactionsWrapper = styled(Wrapper)`

    flex-direction: row;
/* @media screen and (max-width:1000px){
    flex-direction: column;
} */
`;